import type { Element as XmlEl } from "@xmpp/xml"
import { NS_CARBONS } from "../../constants"

export const carbonPayload = (xml: XmlEl): XmlEl | undefined =>
  xml.getChild("sent", NS_CARBONS) ?? xml.getChild("received", NS_CARBONS)
